import React, {MouseEvent} from "react";

import {Button} from "@pg-design/button-module";
import {w100} from "@pg-design/helpers-css";

import {IReelActionButtonType} from "../../../types/IReelActionButtonType";
import {IReelDetails} from "../../../types/IReelDetails";
import {ReelDetailsInquiryFormButton} from "./ReelDetailsInquiryFormButton";

interface IProps {
    reel: IReelDetails;
    onBtnClick?(event?: MouseEvent): void;
    onInquiryFormModalOpen?(): void;
    onInquiryFormModalClose?(): void;
}

export const ReelDetailsCtaButton = (props: IProps) => {
    const {reel} = props;

    switch (reel.action_button_type) {
        case IReelActionButtonType.CustomUrl:
            return (
                <Button
                    href={reel.action_button_url || ""}
                    target="_blank"
                    type="button"
                    variant="filled_primary"
                    size="x-small"
                    css={[w100]}
                    onClick={props.onBtnClick}
                >
                    {reel.action_button_name}
                </Button>
            );
        case IReelActionButtonType.InquiryForm:
            return (
                <ReelDetailsInquiryFormButton
                    reel={reel}
                    onInquiryFormModalOpen={() => {
                        props.onBtnClick?.();
                        props.onInquiryFormModalOpen?.();
                    }}
                    onInquiryFormModalClose={props.onInquiryFormModalClose}
                />
            );
        default:
            return null;
    }
};
import React, {MouseEvent} from "react";

import {Button} from "@pg-design/button-module";
import {w100} from "@pg-design/helpers-css";

import {IReelActionButtonType} from "../../../types/IReelActionButtonType";
import {IReelDetails} from "../../../types/IReelDetails";
import {ReelDetailsInquiryFormButton} from "./ReelDetailsInquiryFormButton";

interface IProps {
    reel: IReelDetails;
    onBtnClick?(event?: MouseEvent): void;
    onInquiryFormModalOpen?(): void;
    onInquiryFormModalClose?(): void;
}

export const ReelDetailsCtaButton = (props: IProps) => {
    const {reel} = props;

    switch (reel.action_button_type) {
        case IReelActionButtonType.CustomUrl:
            return (
                <Button
                    href={reel.action_button_url || ""}
                    target="_blank"
                    type="button"
                    variant="filled_primary"
                    size="x-small"
                    css={[w100]}
                    onClick={props.onBtnClick}
                >
                    {reel.action_button_name}
                </Button>
            );
        case IReelActionButtonType.InquiryForm:
            return (
                <ReelDetailsInquiryFormButton
                    reel={reel}
                    onInquiryFormModalOpen={() => {
                        props.onBtnClick?.();
                        props.onInquiryFormModalOpen?.();
                    }}
                    onInquiryFormModalClose={props.onInquiryFormModalClose}
                />
            );
        default:
            return null;
    }
};
